<template>
  <div>
    <div class="mx-auto mt-16 pt-1" :class="isMobile ? 'w-full px-2' : 'section'">
      <div class="mt-2" :class="isMobile ? 'text-sm p-1' : 'pb-1'">
        <div class="text-center font-bold" :class="isMobile ? 'text-base' : 'text-lg'">～ご利用にあたって～</div>
        <div class="border-2 border-black" :class="isMobile ? 'text-sm px-2 py-1' : 'pb-1'">
          <ul class="mx-4">
            <li>
              ●定期券はご利用開始日の14日前から購入できます。本サイトは、購入日時点で<span
                class="font-bold">有効期間が14日以上残っている定期券をお持ちで、運賃改定前に定期券の購入をご検討されているお客さまに向けた案内サイトです。</span>改定前運賃での購入をご検討される際の参考としてご利用いただくものであり、必ずお安く購入いただけることをお約束するものではありません。<br />
            </li>
            <li class="mt-4">
              ●本サイトは、「現在お持ちの定期券」と「新たにお求めいただく定期券」との重複する日数を放棄し、「運賃改定前に定期券を購入する場合」
              と、「現在お持ちの定期券を有効期間終了までご利用後に、改定後の運賃で購入した場合」を一定の条件に基づいて比較しています。<br />
              <span class="text-red-500">現在お持ちの定期券と新たに購入いただく定期券の重複する期間（＝放棄日数）の払いもどしはできません。</span><br />
              ※ただし、定期券の残りの有効期間が１カ月以上残っている場合、払いもどしができる場合があります。
              <a href="https://www.jreast.co.jp/kippu/22.html" target="_blank"
                class="text-blue-600 underline">きっぷの払いもどし：JR東日本</a>
            </li>
            <li class="mt-4">
              ●新たにお求めいただく定期券は、現在お持ちの定期券と同一の区間・種別および月数であることが前提です。定期券の利用区間や種別が変更になる場合は本サイトのご案内の対象外となります。
            </li>
          </ul>
        </div>
      </div>
      <div class="text-center mt-4">
        <button class="font-bold text-xl rounded-md py-1 px-4 text-white bg-blue-600" @click="next">
          上記内容を了承のうえサイトを利用する
        </button>
      </div>
      <div class="text-center mt-4">
        ※お手持ちの定期券の有効期間が14日間以上残っている場合でも、購入日の14日後を有効開始日とする定期券をお求めいただけます。
        <img :src="require('@/assets/images/terms.jpg')" class="w-2/3 mx-auto">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      accept: false,
    }
  },
  computed: mapGetters({
    isMobile: 'getIsMobile',
    isAccept: 'getIsAccept',
  }),
  mounted() {
    if (this.isAccept) {
      this.openTeikiInput();
    }
  },
  methods: {
    next: function () {
      this.$store.commit('setIsAccept', true);
      this.openTeikiInput();
    },
    openTeikiInput: function () {
      let query = {};
      if (this.$route.query.viaList) {
        query.viaList = this.$route.query.viaList;
      }
      if (this.$route.query.teikiKind) {
        query.teikiKind = this.$route.query.teikiKind;
      }
      if (this.$route.query.teikiValidity) {
        query.teikiValidity = this.$route.query.teikiValidity;
      }
      this.$router.push({ name: 'TeikiInput', query: query });
    },
  }
}
</script>

<style scoped>
.section {
  width: 60rem;
}

.checkbox {
  vertical-align: -.3rem;
}
</style>
